export const API_EXTERNAL_ENDPOINT = 'cottage-reviews/cottage/:cottage_id'

export const API_INTERNAL_ENDPOINT =
  'rurality/v3/cottage-reviews/cottage/detail'
